// @mui
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Typography,
  Button,
  IconButton,
  DialogContent,
  useTheme,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useEffect } from 'react';
import { useDispatch, useSelector } from '../redux/store';
import { resetConfirmState, setLoading, setOpen } from '../redux/slices/confirm';
import Iconify from './Iconify';
import useLocales from '../hooks/useLocales';
// import { resetConfirmState } from '../redux/slices/confirm';

// ----------------------------------------------------------------------

export default function CustomConfirm() {
  const theme = useTheme();

  const { isLoading, open, title, subTitle, onConfirm, onCancel, isInfo, isDanger } = useSelector(
    (state) => state.confirm
  );

  const { translate } = useLocales();

  const dispatch = useDispatch();

  useEffect(() => () => dispatch(resetConfirmState()), []);

  const handleCancel = () => {
    if (onCancel && typeof onCancel === 'function') {
      onCancel();
    }
    dispatch(setOpen(false));
    setTimeout(() => dispatch(resetConfirmState()), 500);
  };

  const handleConfirm = async () => {
    if (onConfirm && typeof onConfirm === 'function') {
      dispatch(setLoading(true));
      await onConfirm();
      dispatch(setLoading(false));
    }

    dispatch(setOpen(false));
    setTimeout(() => dispatch(resetConfirmState()), 500);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={handleCancel}
      sx={isDanger ? { backgroundColor: theme.palette.error.main } : {}}
    >
      <IconButton
        aria-label="close"
        onClick={() => handleCancel()}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          zIndex: 1,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Iconify icon={'ep:close'} />
      </IconButton>
      <DialogTitle>
        <Typography fontWeight={'bold'}>{title}</Typography>
      </DialogTitle>
      <DialogContent sx={{ mt: 1 }}>
        <Typography component={'div'} variant="body2">
          {subTitle}
        </Typography>
      </DialogContent>
      <DialogActions>
        {!isInfo && (
          <Button variant="outlined" color="inherit" onClick={handleCancel}>
            {translate('no')}
          </Button>
        )}

        <LoadingButton
          type="submit"
          variant="contained"
          color={isDanger ? 'error' : 'primary'}
          loading={isLoading}
          disabled={isLoading}
          onClick={handleConfirm}
        >
          {translate(isInfo ? 'Ok' : 'Yes')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
